export const Section1 = {
	heading: 'Exciting News: Business Providers Can Now Join Beacon Discovery',
	para1: {
		content1: 'It’s official—',
		content2_link: 'Beacon Discovery',
		content3:
			' has profiles for Business Providers, unlocking exciting new opportunities to connect with thousands of brands and retailers before, during, and after Natural Products Expo West and Newtopia Now.'
	},
	para2: {
		content1:
			'If you’re a Business Services attendee or exhibitor, your complimentary Beacon Discovery profile is already included with your registration—',
		content2_bold: 'what are you waiting for? ',
		content3: 'Activate it today and spotlight your expertise for the natural products industry.'
	}
};

export const Section2 = {
	heading: 'Why Beacon Discovery is a Must-Have for Business Providers',
	l1: {
		boldcontent: 'Showcase Your Expertise: ',
		content:
			' Your dedicated profile lets you shine by highlighting the unique services and solutions you offer. From consulting and marketing to packaging and beyond, this is your chance to stand out.'
	},
	l2: {
		boldcontent: 'Get Noticed by the Right People: ',
		content:
			'Thousands of brands and retailers are actively searching for innovative solutions—make sure your expertise is front and center. A profile on Beacon Discovery ensures you’re visible to the right audience.'
	},
	l3: {
		boldcontent: 'Stay Visible All Year Long: ',
		content:
			'Your profile isn’t just for Natural Products Expo West or Newtopia Now. With Beacon Discovery, you’ll stay top-of-mind and ready to connect with potential partners long after the show ends, keeping your services in the spotlight year-round.'
	}
};

export const Section3 = {
	heading: "Don't Miss Out!",
	content:
		'Without your complimentary profile, you risk missing valuable connections with brands and retailers who are actively looking for what you offer. Profiles are live—join the Beacon Discovery community and secure your spot on the platform today.'
};

export const Section4 = {
	heading: 'How to Get Started',
	content1: 'Submitting your profile is simple:',
	l1: {
		content: 'Open ',
		content_link: 'this form'
	},
	l2: {
		content: 'Follow the instructions based on your registration type:',
		subcontent: {
			l1: {
				bold: 'If attending only (not exhibiting): ',
				content:
					' Select “NEW! Beacon subscription for Business Services, not exhibiting at an event.”'
			},
			l2: {
				bold: ' If your company is exhibiting: ',
				content: 'Select the event your company is participating in to proceed'
			}
		}
	},
	l3: {
		content: 'Submit your details to activate your profile.'
	},
	l4: {
		content: 'Start making those connections!'
	}
};

export const Section5 = {
	heading: "Questions? We're Here to Help!",
	content:
		'Need assistance or have questions about setting up your profile? Reach out to us—we’re here to make it easy.'
};

export enum Images {
	natural_brand = 'https://s44021.pcdn.co/wp-content/uploads/2025/02/fb4f908e-0c1a-4da8-a6a0-3801b50c317c.jpg'
}

export enum Links {
	beacon_discovery = 'https://beaconapp.newhope.com/',
	form_alchemer = 'https://survey.alchemer.com/s3/8063876/StandardsFormvs2025',
	button_contact_us = 'https://beacon.newhope.com/contact-us/'
}
